module.exports = __webpack_public_path__ + "static/media/Wikisource-logo.e4dd04b5.png";